module.exports = __webpack_public_path__ + "static/img/89090C_3_R_20190816_LC.6906089.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/89090C_3_R_20190816_LC.png
// module id = PogP
// module chunks = 0